import React, { Fragment } from 'react';

// Don't touch this import
import { fetchQueryResultsFromTermAndValue } from '../api';

const Searchable = ({ setIsLoading, setSearchResults, description, term}) => {
  return (
    <span className="content">
      <a href='#'
        onClick={async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
          const data = await fetchQueryResultsFromTermAndValue(term, description);
          await setSearchResults(data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
      }}>{ description }</a>
    </span>
  )
}


const Feature = ({ featuredResults, setIsLoading, setSearchResults }) => {
    return ( 
      featuredResults ?
        <main id="feature">
          <div className="object-feature">
            <header>
              <h3>{ featuredResults.title }</h3>
              <h4>{ featuredResults.dated }</h4>
            </header>
            <section className="facts">
{/* I did all my descriptions with a ternary check to make sure the api had them,
    but I didn't with the culture, I saw that even unidentified cultures were still labeled in the api.
    do let me know if that is wrong though! */}
              {
                <>
                  <span className="title">Culture</span>
                  <Searchable  
                    setIsLoading={ setIsLoading } 
                    setSearchResults={ setSearchResults } 
                    description={ featuredResults.culture }
                    term={ 'culture' }
                  />
                </>
              }
                
              {
                featuredResults.description ?
                  <>
                    <span className="title">Description</span>
                    <span className="content">{ featuredResults.description }</span>
                  </>
                : null
              }
              
              {
                featuredResults.style ?

                <>
                  <span className="title">Style</span>
                  <span className="content">{ featuredResults.style }</span>
                </>

                : null
              }
              
              {
                featuredResults.technique ?
                <>
                  <span className="title">Technique</span>
                  <Searchable  
                    setIsLoading={ setIsLoading } 
                    setSearchResults={ setSearchResults } 
                    description={ featuredResults.technique }
                    term={ 'technique' }
                  />
                </>
                : null
              }
              
              {
                featuredResults.medium?
                <>
                  <span className="title">Medium</span>
                  <Searchable 
                    setIsLoading={ setIsLoading } 
                    setSearchResults={ setSearchResults } 
                    description={ featuredResults.medium.toLowerCase() }
                    term={ 'medium' }
                  />
                </>
                : null
              }
              
              {
                featuredResults.dimensions ?
                <>
                  <span className="title">Dimensions</span>
                  <span className="content">{ featuredResults.dimensions }</span>
                </>
                : null
              }

              {
                featuredResults.people ?
                
                  featuredResults.people.map((person, idx) => 
                    <React.Fragment key={ person.personid }>
                      <span key={ idx } className='title'>Person</span>
                      <Searchable
                        key={ person.personid + idx} 
                        setIsLoading={ setIsLoading } 
                        setSearchResults={ setSearchResults } 
                        description={ person.name }
                        term={ 'person' }
                      />
                    </React.Fragment>
                    )
                  : null
              }
              
              {
                featuredResults.department ?
                <>
                  <span className="title">Department</span>
                  <span className="content">{ featuredResults.department }</span>
                </>
                : null
              }
              
              {
                featuredResults.division ?
                <>
                  <span className="title">Division</span>
                  <span className="content">{ featuredResults.division }</span>
                </>
                : null
              }
              
              {
                featuredResults.contact ?
                <>
                  <span className="title">Contact</span>
                  <span className="content">{ featuredResults.contact }</span>
                </>
                : null
              }

              {
                featuredResults.creditline ?
                <>
                  <span className="title">Credit line</span>
                  <span className="content">{ featuredResults.creditline }</span>
                </>
                : null
              }
            </section>
{/* Start of image section of main Feature. */}
            <section className="photos">
              {
                featuredResults.images ?
                  featuredResults.images.map((img, idx) => 
                  <img 
                    key={ idx } 
                    src={ img.baseimageurl } 
                    alt={ featuredResults.description } 
                  />
                 )
                : null
              }
                </section>
                </div>
                </main>
      // end of main ternary for display.
      : <main id="feature"></main>
    )
}
    
    
    export default Feature;
    
